// extracted by mini-css-extract-plugin
module.exports = {"container":"gVUed5fMdJC9eu5N7is12"};